module.exports = __webpack_public_path__ + "static/media/Cosmoem_gaussian2.3e88397e.png";